<template>
  <a-row class="content-fix">
    <a-row class="content-title" type="flex">
      <h2>Все категории</h2>

      <a-button
        style="margin-left: auto"
        type="primary"
        @click="$router.push({ name: 'category-alerts-create' })"
      >
        <a-icon type="plus" />Добавить
      </a-button>
    </a-row>

    <a-table
      :columns="columns"
      :data-source="$store.getters['categoryAlerts/sortedList']"
      :loading="loading"
      :pagination="{ defaultTabPageSize }"
      :row-key="(record) => record.id"
    >
      <template slot="id" slot-scope="item">
        <b>{{ item.id }}</b>
      </template>
      <template slot="news_title" slot-scope="item">
        <router-link
          :to="{
            name: 'category-alerts-list',
            params: {
              cat_id: item.id
            }
          }"
          class="td-post-item"
          tag="span"
        >
          <span v-if="item.is_main" class="mr-1">
            <a-icon type="pushpin" />
          </span>
          <b>{{ getFirstFulfilled(JSON.parse(item.title)).text }}</b>
          <span>
            <template v-for="(title, key) in JSON.parse(item.title)">
              <a-tag v-if="title" :key="key">
                <img
                  width="14"
                  class="flag-svg__tab"
                  :src="contentLanguages[key].flagSrc"
                  :alt="key"
                />
                {{ contentLanguages[key].abr }}
              </a-tag>
            </template>
          </span>
        </router-link>
      </template>
      <template slot="operation" slot-scope="item">
        <a-icon
          class="action-btns"
          type="edit"
          @click="
            $router.push({
              name: 'category-alerts-edit',
              params: { cat_id: item.id }
            })
          "
        />
        <a-popconfirm
          cancel-text="Нет"
          ok-text="Да"
          title="Вы действительно хотите удалить?"
          @confirm="removeItem(item)"
        >
          <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
        </a-popconfirm>
      </template>
    </a-table>
    <a-row class="mt-1">
      <!-- <a-pagination @change="toPage" :current="page" :total="tableProps.count" /> -->
    </a-row>
  </a-row>
</template>

<script>
import { CONTENT_LANGUAGES } from "@/constants"
const columns = [
  {
    title: "ID",
    key: "id",
    scopedSlots: { customRender: "id" }
  },
  {
    title: "Название",
    key: "title",
    scopedSlots: { customRender: "news_title" }
  },
  {
    title: "Действие",
    key: "operation",
    width: 60,
    scopedSlots: { customRender: "operation" }
  }
]

export default {
  data: () => ({
    loading: false,
    columns,
    categoryForm: {},
    categoryNews: [],
    tableProps: {
      results: [],
      count: 1
    },
    page: 1
  }),
  computed: {
    contentLanguages: () => CONTENT_LANGUAGES
  },
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    },
    "$i18n.locale": {
      handler: "fetchData",
      immediate: true
    }
  },
  methods: {
    getFirstFulfilled(fields) {
      let lang = this.$i18n.locale
      if (!fields) return {}
      if (fields[lang]) {
        return {
          text: fields[lang],
          lang: lang
        }
      } else {
        const lang = Object.keys(fields).find((l) => fields[l])
        if (!lang) {
          return {}
        }
        return {
          text: fields[lang],
          lang: lang
        }
      }
    },
    async removeItem(item) {
      try {
        const r = await this.$store.dispatch(
          "categoryAlerts/removeItemAction",
          item.id
        )

        if (r) {
          if (this.tableProps && this.tableProps.results) {
            const f = this.tableProps.results.findIndex(
              (elem) => elem.id == item.id
            )

            if (f != -1) {
              this.tableProps.results.splice(f, 1)
              this.$message.succes("Успешно удалено")
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    toPage(arg) {
      this.page = arg || 1
      this.$router.push({ query: { page: this.page } })
    },
    async fetchData() {
      this.loading = true

      try {
        await this.$store.dispatch("categoryAlerts/fetch")
      } catch (e) {
        console.log(e)
      }

      this.loading = false
    }
  }
}
</script>

<style></style>
